export { default as ListarClientes } from './Listar';
export { default as DetalleCliente } from './Agenda';
export { default as CrearCliente } from './Nuevo';
export { default as ListarProveedores} from './ListarProveedores';